import { authFetch } from '@/services/apiClient'

export interface TestResultInfo {
  status: 'SUBMITTED' | 'SKIPPED'
  score: number | null
  max_score: number | null
  percent: number | null
  passed: boolean | null
  submitted_at: string | null
}

interface TestStatusBase {
  test_id: number
  title: string
  question_count: number
  max_score: number
  result: TestResultInfo | null
}

export interface PreTestStatus extends TestStatusBase {
  done: boolean          // ทำแล้วหรือข้ามแล้ว = ไม่ถามอีก
}

export interface PostTestStatus extends TestStatusBase {
  pass_percent: number
  passed: boolean
  unlocked: boolean      // เรียนครบทุกบทแล้ว
}

export interface CourseTestsStatus {
  pre: PreTestStatus | null
  post: PostTestStatus | null
}

export interface TakeTest {
  test_id: number
  test_type: 'PRE' | 'POST'
  title: string
  pass_percent: number | null
  max_score: number
  questions: { question_id: number; question_text: string; options: string[]; score: number }[]
}

export interface SubmitResult extends TestResultInfo {
  test_type: 'PRE' | 'POST'
  pass_percent: number | null
  course_completed: boolean
}

// backend ตอบ {success, data} เมื่อสำเร็จ และ {error, status} เมื่อผิดพลาด
async function unwrap<T>(res: Response, fallback: string): Promise<T> {
  let json: { success?: boolean; data?: T; error?: string; message?: string }
  try {
    json = await res.json()
  } catch {
    throw new Error('เชื่อมต่อเซิร์ฟเวอร์ไม่สำเร็จ')
  }
  if (!res.ok || !json.success || json.data === undefined) throw new Error(json.error || json.message || fallback)
  return json.data
}

export const getCourseTestsStatus = async (courseId: number): Promise<CourseTestsStatus> =>
  unwrap(await authFetch(`/courses/${courseId}/tests`), 'โหลดแบบทดสอบไม่สำเร็จ')

export const getTestForTaking = async (testId: number): Promise<TakeTest> =>
  unwrap(await authFetch(`/tests/${testId}`), 'โหลดแบบทดสอบไม่สำเร็จ')

export const submitTest = async (testId: number, answers: Record<number, number>): Promise<SubmitResult> =>
  unwrap(await authFetch(`/tests/${testId}/submit`, { method: 'POST', body: JSON.stringify({ answers }) }), 'ส่งคำตอบไม่สำเร็จ')

export const skipTest = async (testId: number): Promise<TestResultInfo> =>
  unwrap(await authFetch(`/tests/${testId}/skip`, { method: 'POST' }), 'ข้ามแบบทดสอบไม่สำเร็จ')
